import { filter, flatten, values } from 'lodash-es'

const transformToUpsertScrapingTagGroup = ({
  id,
  alias,
  description,
  ...data
}) => {
  const tagIds = filter(flatten(values(data)))
  return { id, alias, description, tagIds }
}

export default transformToUpsertScrapingTagGroup
